import { Api } from "@mcleod/core";
import { AutogenLayoutFuelDetailReport } from "./autogen/AutogenLayoutFuelDetailReport";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class FuelDetailReport extends AutogenLayoutFuelDetailReport {

    private fuel_interface_id:string;

    override onLoad() {
        this.getCardProvider();
    }

    async getCardProvider() {
        const response = await Api.search("lme/dispatch/asset/fuel-interface-configured", {});

        if (response.actual_row_count === 1) {
            this.textboxCardProvider.required = false;
            this.textboxCardProvider.requiredDuringSearch = false;
            this.textboxCardProvider.visible = false;
            const data = response?.data?.[0];
            this.fuel_interface_id = data.id;
        }
    }

    /** This is an event handler for the beforeExecution event of sourceFuelDetail. */
    sourceFuelDetailBeforeExecution(event: DataSourceExecutionEvent) {
        if (this.fuel_interface_id) {
            event.filter.fuel_interface_id = this.fuel_interface_id;
        }
    }
}